var eventsTools = {
    handleLinkClick: function (e) {
        e.preventDefault();
        e.stopPropagation();

        var link = $(e.currentTarget),
            linkText = link.text(),
            tabsLabel = link.parents('.tabs').find('.tabs__label-active'),
            links = link.parents('.tabs').find('.tabs__link'),
            href = link.attr('href'),
            container = link.parents('.tabs').find('[data-tab="' + href + '"]'),
            containers = link.parents('.tabs').find('[data-tab]');

        if (link.parents('.product').length === 0) {
            window.location.hash = href;
        }
        if (tabsLabel.length !== 0) {
            tabsLabel.html(linkText);
        }
        if (!link.hasClass('active')) {
            links.removeClass('active');
            link.addClass('active');
            containers.removeClass('active');
            container.addClass('active');
        }
    },

    handleLabelClick: function (e) {
        e.preventDefault();
        e.stopPropagation();

        var label = $(e.currentTarget),
            labelParent = label.parents('.tabs'),
            tabsHolder = labelParent.find('.tabs__control-holder');

        if (!label.hasClass('is_active')) {
            label.addClass('is_active');
            tabsHolder.stop().slideDown(300, function () {
                $(this).removeAttr('style').addClass('is_active');
            });
        } else {
            label.removeClass('is_active');
            tabsHolder.stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
            });
        }
    },

    handleSubmenuLabelClick: function (e) {
        e.preventDefault();
        e.stopPropagation();

        var label = $(e.currentTarget).parents('.submenu__label'),
            labelParent = label.parents('.header__submenu'),
            tabsHolder = labelParent.find('.submenu__holder');

        if (!label.hasClass('is_active')) {
            label.addClass('is_active');
            tabsHolder.stop().slideDown(300, function () {
                $(this).removeAttr('style').addClass('is_active');
            });
        } else {
            label.removeClass('is_active');
            tabsHolder.stop().slideUp(300, function () {
                $(this).removeAttr('style').removeClass('is_active');
            });
        }
    }
};

$(document).ready(function () {
    $(document).on('click', '.tabs__link', function (e) {
        eventsTools.handleLinkClick(e);
    });

    $(document).on('click', '.tabs__label', function (e) {
        eventsTools.handleLabelClick(e);
    });

    $(document).on('click', '.submenu__label-active', function (e) {
        eventsTools.handleSubmenuLabelClick(e);
    });

    $(document).on('click', '.js_open_price', function (e) {
        $(this).toggleClass('js_active')
    });

    $(document).on('click', '.js_open_chars', function (e) {
        $(this).next('.price-table__td--chars').slideToggle("slow");
        $(this).toggleClass('js_active');
    });
});
